import React, { Component } from 'react'
import ScrollToTop from '../../../components/ScrollToTop'
import MenuSider from '../../../components/MenuSider'
import IntlMessages from '../../../util/IntlMessages';
import { DatePicker, Tag, Table, Upload, Input, Select, Button, message, Modal, Spin, Collapse, Switch } from 'antd';
import { connect } from 'react-redux'
import './capa.scss'
import moment from 'moment';
import { Odata_Url, Constants } from '../../../Constants/Constants'
import TextArea from 'antd/lib/input/TextArea';
import { toUpperKey } from '../../../util/helpper'
import { Link } from 'react-router-dom';

const { Column } = Table
const axios = require('axios');
const Search = Input.Search
const mode = {
    ReadOnly: 1,
    Assignee: 2,
    Manager: 3
}
const Panel = Collapse.Panel;
const Option = Select.Option
var Token

const customPanelStyle = {
    background: '#f7f7f7',
    borderRadius: 4,
    marginBottom: 24,
    border: 0,
    overflow: 'hidden'
}
const columns_rootcause = [
    {
        key: 1,
        title: <IntlMessages id='menu.master_category' />,
        dataIndex: "category_name",
        width: "50%"
    },
    {
        key: 2,
        title: <IntlMessages id='Summary.root_cause' />,
        dataIndex: "root_cause",
        width: "50%"
    }
];

const columns_unsafe_detail_category = [
    {
        key: 1,
        title: <IntlMessages id='menu.master_category' />,
        dataIndex: "category_name",
        width: "50%"
    },
    {
        key: 2,
        title: <IntlMessages id='Summary.unsafe_detail' />,
        dataIndex: "detail",
        width: "50%"
    }
];


export default class Capa extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ObtranID: '',
            PageMode: mode.ReadOnly,
            visible: false,
            tableLoading: false,
            onLoading: false,
            dataObservation: [],
            dataWorkflow: [],
            dataCompany: "",
            dataShift: [],
            dataArea: [],
            dataSumArea: [],
            dataJobType: [],
            datadetail: [],
            datarootcause: [],
            dataAttachment: [],
            dataobservertype: [],
            dataUser: [],
            data_image: [],
            type_observation: "",
            previewVisible: false,
            previewImage: '',
            fileList: [],
            previewVisible: false,
            previewImage: '',
            visible: false,
            near_miss: false,
            isChangeAssignee: false,
            tempSelectedUser: {},
            selectedUser: {},
            onloadUser: false,
            user: [],
            capaAction: '',
            remark: '',
            completeDate: '',
            status: '',

            clicked: false,
        }

        this.handleUserOk = this.handleUserOk.bind(this)
        this.handleUserCalcel = this.handleUserCalcel.bind(this)
        this.handleShowSearch = this.handleShowSearch.bind(this)
        this.handleSearch = this.handleSearch.bind(this)
    }

    componentDidMount() {
        this.setState({ onLoading: true })
        let stateEng = JSON.parse(window.localStorage.getItem('state'))
        let isEng = stateEng.setting.locale.locale == 'en'
        this.setState({ isEng: isEng })
        let transactionNo = this.props.match.params.id
        const state = JSON.parse(window.localStorage.getItem('User_Info'))
        const user_id = state.PKUserID
        this.setState({ ObtranID: transactionNo })
        this.getObservationData(transactionNo).then(res => {
            let page_mode = res.UserResponsible === user_id && res.CurrentStatus !== 2 ? mode.Assignee : res.ResponsibleManager === user_id ? mode.Manager : mode.ReadOnly
            page_mode = res.CurrentStatus === 6 ? mode.ReadOnly : page_mode
            if (res.CurrentStatus === 5)
                page_mode = mode.readOnly
            this.getUserInfo(res.UserCreate).then(user_create => {
                this.getUserInfo(res.UserResponsible).then(user_responsible => {
                    res.CreateByName = this.state.isEng ? user_create.UserFullName_ENG : user_create.UserFullName_TH
                    res.ResponsibleName = this.state.isEng ? user_responsible.UserFullName_ENG : user_responsible.UserFullName_TH
                    this.setState({
                        dataObservation: res,
                        isFirst: res.DueDate === null,
                        PageMode: page_mode,
                        UserInfo: user_responsible,
                        CreateInfo: user_create
                    })
                    this.initData(transactionNo);
                    this.initImage(transactionNo);
                })
            })

            this.getWorkflow(transactionNo).then(res_workflow => {
                this.setState({
                    dataWorkflow: res_workflow
                })
            })
            this.getStatus().then(status => {
                this.setState({
                    status: status
                })
            })
        })
    }

    componentDidUpdate(prevProps, prevState) {
        let stateEng = JSON.parse(window.localStorage.getItem('state'))
        let isEng = stateEng.setting.locale.locale == 'en'
        if (isEng !== prevState.isEng) {
            this.setState({ isEng: isEng })
            let dataObservation = this.state.dataObservation
            dataObservation.CreateByName = this.state.isEng ? (this.state.CreateInfo || {}).UserFullName_ENG : (this.state.CreateInfo || {}).UserFullName_TH
            dataObservation.ResponsibleName = isEng ? (this.state.UserInfo || {}).UserFullName_ENG : (this.state.UserInfo || {}).UserFullName_TH
            this.setState({ dataObservation: dataObservation })
        }

    }

    async getObservationData(ObtranID) {

        var token = await this.getToken();
        let tokenHeader = {
            headers: {
                "Authorization": "Bearer " + token,
            }
        };

        let url = 'api/ObservationTransaction/GetObservation?PkObTranID=' + ObtranID
        let data = await axios.get(Constants.BASE_URL + url, tokenHeader)
            .then((response) => {
                return toUpperKey(response.data);
            }, (error) => {
                console.log(error)
                this.setState({ tableLoading: false });
            })
        return data
    }

    async getWorkflow(ObtranID) {
        let data = await axios.get(Constants.BASE_URL + 'auth/token').then(async (response) => {
            Token = response.data
            let data = await axios.get(Odata_Url + `OWorkflow?$filter=ObservationId eq ` + ObtranID,
                {
                    headers: { "Authorization": "Bearer " + Token }
                }
            ).then(async (response) => {
                const data = [];
                response.data.value.forEach(function (element) {
                    data.push(element);
                });
                return data
            }, (error) => {
                console.log(error)
            })
            return data
        }, (error) => {
            if (401 === error.response.status) {
                window.location.href = "auth";
            }
            console.log(error)
        })
        return data
    }

    async getUserInfo(user_id) {
        let user = JSON.parse(window.localStorage.getItem('User_Info'))
        let userId = user_id === undefined ? user.PKUserID : user_id
        var Token
        let res = await axios.get(Constants.BASE_URL + 'auth/token')
            .then(async (response) => {

                Token = response.data

                let tokenHeader = {
                    headers: { "Authorization": "Bearer " + Token }
                };
                let user_info = await axios.get(Constants.BASE_URL + 'api/User/GetByPKUserID?PKUserID=' + userId, tokenHeader)
                    .then(res => {
                        return toUpperKey(res.data);
                    })
                return user_info;
            })
            .catch(err => {
                if (401 === err.response.status) {
                    window.location.href = "auth";
                }
            });
        return res;
    }

    async getStatus() {
        var Token
        let res = await axios.get(Constants.BASE_URL + 'auth/token')
            .then(async (response) => {
                Token = response.data
                let status = await axios.get(
                    Odata_Url + 'OStatusMD?$filter=IsActived eq true',
                    {
                        headers: {
                            "Authorization": "Bearer " + Token,
                        }
                    }
                ).then(res => {
                    const data = [];
                    res.data.value.forEach(function (element) {
                        data.push(element);
                    });
                    return data;
                })
                return status;
            }).catch(err => {
                if (401 === err.response.status) {
                    window.location.href = "auth";
                }
            });
        return res;
    }

    initData(transactionNo) {

        this.getToken().then(token => {

            let tokenHeader = {
                headers: {
                    "Authorization": "Bearer " + token,
                }
            };

            axios.get(Constants.BASE_URL + 'api/Observation/GetObservationJobDetail?PkObTranID=' + transactionNo, tokenHeader)
                .then((response) => {
                    var data = []
                    response.data.forEach(function (element) {
                        let jobtype = JSON.parse(window.localStorage.getItem('Jobtype'))
                        let job = jobtype.find(x => x.PKJobTypeID === element.jobTypeID)
                        data.push(job)
                    });
                    this.setState({
                        dataJobType: data,
                    })
                },
                    (error) => {
                        console.log(error);
                    });

            axios.get(Odata_Url + 'OObservation_ObserverType?$filter=IsActived eq true and ObTranID eq ' + transactionNo,
                {
                    headers: {
                        "Authorization": "Bearer " + Token,
                    }
                }
            ).then((response) => {
                var data = []

                response.data.value.forEach(function (element) {
                    data.push(element.ObserverType_Name)
                });
                // console.log(data);
                this.setState({ dataobservertype: data })
            },
                (error) => {
                    console.log(error);
                });

            var count_rootcause = 0;
            var count_nearmiss = 0;

            axios.get(Constants.BASE_URL + 'api/Observation/GetObservationCategoryDetail?PkObTranID=' + transactionNo, tokenHeader)
                .then((response) => {
                    var data_rootcause = []
                    var data_detail = []
                    response.data.forEach(function (element) {
                        if (element.root_cause !== null) {
                            data_detail.push(toUpperKey(element))
                            count_rootcause++
                        }
                        if (element.near_miss) {
                            count_nearmiss++
                        }
                    });
                    this.setState({
                        datarootcause: data_rootcause,
                        datadetail: data_detail
                    })
                    if (count_rootcause !== 0) {
                        this.setState({ type_observation: "Unsafe" })
                    } else {
                        this.setState({ type_observation: "Safe" })
                    }
                    if (count_nearmiss !== 0) {
                        this.setState({
                            near_miss: true
                        })
                    }
                    this.setState({ onLoading: false })
                },
                    (error) => {
                        console.log(error);
                        this.setState({ onLoading: false })
                    });
        });
        
    }

    initImage(transactionNo) {
        let ObtranID = transactionNo
        var Token
        // this.setImage()
        let files = this.state.fileList
        return axios.get(Constants.BASE_URL + 'auth/token').then(response => {
            Token = response.data
            return axios.get(Odata_Url + 'OAttachment?$filter=IsActived eq true and ObtranID eq ' + ObtranID,
                { headers: { "Authorization": "Bearer " + Token } }).then(res => {
                    let image_guid = []
                    res.data.value.forEach(function (element) {
                        if (files.filter(x => x.uid === element.Guid).length === 0)
                            image_guid.push(element.Guid)
                    });

                    let fileList = files
                    let wait_map = image_guid.map(l => {
                        return axios.get(Constants.BASE_URL + 'api/Attachment/GetImageByGuid?guid=' + l).then((response) => {
                            if (response.data) {
                                fileList.push({
                                    uid: response.data.guid,
                                    name: response.data.filename,
                                    status: 'done',
                                    url: 'data:image/jpeg;base64,' + response.data.data
                                });
                            }
                        })
                    })
                    return Promise.all(wait_map).then(() => {
                        if (image_guid.length > 0 && fileList.length === 0)
                            message.error('Can\'t get image(s), Please contact It one.');
                        this.setState({
                            fileList: fileList
                        })
                    })
                })
        }).catch(err => {
                if (401 === err.response.status) {
                    window.location.href = "auth";
                }
            });
    }

    handleShowSearch() {
        this.setState({
            visible: true
        })
    }

    handleSearch(str) {
        this.setState({
            onloadUser: true
        })
        const axios = require('axios');

        this.getToken().then(token => {

            let tokenHeader = {
                headers: { "Authorization": "Bearer " + token }
            };

            axios.get(Constants.BASE_URL + 'api/User/Search?q=' + str, tokenHeader)
                .then((response) => {
                    const data = [];
                    response.data.map((l, i) => {
                        data.push(l);
                    })

                    this.setState({
                        user: data,
                        onloadUser: false
                    })
                })
        });

        
    }

    handleUserOk() {
        let tempSelectedUser = this.state.tempSelectedUser
        this.setState({ visible: false })
        this.getUserInfoByUsername(tempSelectedUser.manager).then((res) => {
            tempSelectedUser.ResponsibleManagerId = res.PkUserID
            this.setState({
                selectedUser: tempSelectedUser,
            })
        })

    }

    handleUserCalcel() {
        this.setState({
            visible: false
        })
    }

    handleChangeAction = value => {
        this.setState({
            capaAction: value
        })
    }

    handleChangeRemark = e => {
        this.setState({
            remark: e.target.value
        })
    }

    handlePreview = (file) => {
        this.setState({
            previewImage: file.url || file.thumbUrl,
            previewVisible: true,
        });
    }

    handleChange = ({ fileList }) => {
        this.setState({
            fileList: fileList
        })
    }

    handleSubmit() {
        this.setState({ onLoading: true, clicked: true })
        const state = JSON.parse(window.localStorage.getItem('User_Info'))
        let data = this.state.dataObservation
        data.Action = this.state.capaAction

        if (this.state.isFirst && !this.state.isChangeAssignee) {
            if (data.DueDate === null || data.DueDate === '') {
                message.error("Please select Due Date.")
                this.setState({ onLoading: false, clicked: false })
                return
            } else {
                data.Mode = "duedate";
            }
        }
        else if (!this.state.isChangeAssignee && data.CurrentStatus !== 7) {
            if (this.state.capaAction == '') {
                message.error("Please select CAPA action.")
                this.setState({ onLoading: false, clicked: false })
                return
            } else if (this.state.capaAction === 'completed' && this.state.completeDate === '') {
                message.error("Please enter complete date.")
                this.setState({ onLoading: false, clicked: false })
                return
            } else {
                if (this.state.remark === '') {
                    message.error("Please enter remark.")
                    this.setState({ onLoading: false, clicked: false })
                    return
                } else {
                    data.CurrentStatus = 2 // 2 is waiting for approve
                    data.NextStatus = this.state.capaAction === 'completed' ? 6 :
                        this.state.capaAction === 'revised' ? 7 :
                            this.state.capaAction === 'cancelled' ? 5 : 0
                }
            }
            data.Remark = this.state.remark
            data.CompleteDate = this.state.completeDate
        } else if (data.CurrentStatus === 7) {
            data.CurrentStatus = 1
            data.NextStatus = 7
        } else {
            if (Object.keys(this.state.selectedUser).length === 0) {
                message.error("Please choose user.")
                this.setState({ onLoading: false, clicked: false })
                return
            } else {
                data.Mode = "change";
                data.UserResponsible = this.state.selectedUser.userId
                data.ResponsibleManager = this.state.selectedUser.ResponsibleManagerId
                data.ActionType = "forward"
                data.DueDate = null
            }
        }


        data.ActionById = state.PKUserID
        data.ActionByName = state.UserFullName_TH

        let ObtranEn = JSON.stringify(data)

        this.getToken().then(token => {

            let tokenHeader = {
                headers: {
                    "Authorization": "Bearer " + token,
                }
            };

            axios.post(Constants.BASE_URL + "api/ObservationTransaction/ActionRequest", { Obtran: ObtranEn }, tokenHeader)
                .then((response) => {
                    //Finished the fob
                    this.setState({ onLoading: false })
                    message.success("Your transaction has been successfully.")
                    setTimeout(() => this.props.history.push('/capa_assignee'), 2000);
                    return
                }, (error) => {
                    this.setState({ onLoading: false, clicked: false })
                    console.log(error);
                    message.error("Something went wrong please try again.")
                    return
                })
        });

        return
    }

    handleApprove(action) {
        this.setState({ onLoading: true, clicked: true })
        const state = JSON.parse(window.localStorage.getItem('User_Info'))
        let data = this.state.dataObservation
        data.Remark = this.state.remark
        data.ActionById = state.PKUserID
        data.ActionByName = state.UserFullName_TH
        data.IsApprove = action === 'approve';
        data.EmailLink = window.location.href;

        if (data.IsApprove) {
            data.CurrentStatus = data.NextStatus
            data.NextStatus = 1
        } else {
            if (this.state.remark === '') {
                message.error("Please enter remark.")
                this.setState({ onLoading: false, clicked: false })
                return
            }
            data.CurrentStatus = data.PreviousStatus
            data.NextStatus = 1
        }

        let ObtranEn = JSON.stringify(data)

        this.getToken().then(token => {

            let tokenHeader = {
                headers: {
                    "Authorization": "Bearer " + token,
                }
            };

            axios.post(Constants.BASE_URL + "api/ObservationTransaction/ActionApprove", { Obtran: ObtranEn }, tokenHeader)
                .then((response) => {
                    //Finished the fob
                    this.setState({ onLoading: false })
                    message.success("Your transaction has been successfully.")
                    setTimeout(() => this.props.history.push('/capa_manager'), 2000);
                    return
                },
                    (error) => {
                        this.setState({ onLoading: false, clicked: false })
                        console.log(error);
                        message.error("Something went wrong please try again.")
                        return
                    })

        });

        
        return
    }

    async getUserInfoByUsername(username) {

        let token = await this.getToken();
        let tokenHeader = {
            headers: { "Authorization": "Bearer " + token }
        };

        let user_info = await axios.get(Constants.BASE_URL + 'api/User/GetByUsername?username=' + username, tokenHeader)
            .then(res => {
                // const data = [];
                // res.data.forEach(function (element) {
                //     data.push(toUpperKey(element));
                // });
                return toUpperKey(res.data);
            })
        return user_info;
    }

    //showdetail = (obtran) => {
    //    this.props.history.push({
    //        pathname: "/newobservation_basic_info",
    //        state: { Obtran: obtran, mode: 'view' }
    //    });
    //}

    getToken() {
        var $getToken = new Promise((resolve, reject) => {
            axios.get(Constants.BASE_URL + 'auth/token').then((res) => {
                resolve(res.data);
            }).catch(err => {
                if (401 === err.response.status) {
                    window.location.href = "auth";
                }
                reject(err);
            });
        });
        return $getToken;
    }

    render() {

        console.debug("this.state", this.state);

        const { dataJobType, near_miss, type_observation, datadetail } = this.state;
        // console.log(dataUser)
        var data_category_unsafe = []
        var data_rootcause = []
        var cate = JSON.parse(window.localStorage.getItem('Category'))
        const Rootcause = JSON.parse(window.localStorage.getItem("Rootcause"))
        var count_data_category_unsafe = 0
        var count_data_rootcause = 0
        datadetail.map((l, i) => {
            if (l.Detail !== null) {
                if (l.Type_Of_Category === "Unsafe") {

                    data_category_unsafe[count_data_category_unsafe] = { category_name: this.state.isEng ? cate[i].Category_Name_EN : cate[i].Category_Name, detail: l.Detail }
                    count_data_category_unsafe++;
                    data_rootcause[count_data_rootcause] = { category_name: this.state.isEng ? cate[i].Category_Name_EN : cate[i].Category_Name, root_cause: this.state.isEng ? Rootcause.find(x => x.Rootcause === l.Root_cause).Rootcause_EN : l.Root_cause }
                    count_data_rootcause++;
                }
            }
            return null
        })
        var observation_detail = this.state.dataObservation
        var Unsafe_detail_corrective_action = observation_detail.Unsafe_detail_corrective_action
        var Unsafe_detail_next_action = observation_detail.Unsafe_detail_next_action
        var Safe_detail = observation_detail.Safe_detail
        if (Unsafe_detail_corrective_action === "") {
            Unsafe_detail_corrective_action = "-"
        }
        if (Unsafe_detail_next_action === "") {
            Unsafe_detail_next_action = "-"
        }
        if (Safe_detail === "") {
            Safe_detail = "-"
        }

        let action_type = this.state.isChangeAssignee ? <IntlMessages id='forward' /> : <IntlMessages id={this.state.dataObservation.ActionType} />

        const genSwitchCangeAssignee = () => (
            <>
                {
                    !(this.state.dataObservation.CurrentStatus === 7) ? (
                        <>
                            <span onClick={event => {
                                this.setState({
                                    isChangeAssignee: !this.state.isChangeAssignee
                                })
                                event.stopPropagation();
                            }}><IntlMessages id='Capa.ChangeResponsible' /> </span>
                            <Switch checked={this.state.isChangeAssignee} onChange={() => ChangeAssignee()} onClick={(checked, event) => {
                                event.stopPropagation();
                            }} />
                        </>
                    ) : null
                }
            </>
        )

        const ChangeAssignee = () => {
            this.setState({
                isChangeAssignee: !this.state.isChangeAssignee
            })
        }

        const rowSelection = {
            type: 'radio',
            onSelect: (record, selected, selectRows) => {
                this.setState({
                    tempSelectedUser: record
                })
            }
        }

        return (
            <div style={{ width: "100%" }} className="capa">
                <Spin spinning={this.state.onLoading} size="large" style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }} tip="Loading...">
                    <ScrollToTop />
                    <MenuSider title={<IntlMessages id="Capa.Header" />}>
                        <div className='fullVW'>
                            <div style={{ width: "100%", padding: "13px 5% 0 5% " }}>
                                <div className='status_header' key="Job">
                                    <IntlMessages id="Action.status_job_observed" />
                                    <div className='color'>
                                        <IntlMessages id="Action.Unsafe" />
                                    </div>
                                </div>
                                <Collapse bordered={false} defaultActiveKey={["image", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13"]}>
                                    {
                                        (near_miss) && (
                                            <Panel header={<IntlMessages id="Summary.near_miss" />} key="2" showArrow={false} style={customPanelStyle}>
                                                <IntlMessages id="Summary.near_miss_this" />
                                            </Panel>
                                        )
                                    }
                                    {
                                        (this.state.fileList.length !== 0) && (
                                            <Panel header={<IntlMessages id="Summary.image" />} key="image" showArrow={false} style={{ ...customPanelStyle, marginTop: 24, marginBottom: 10 }}>
                                                <Upload
                                                    listType="picture-card"
                                                    fileList={this.state.fileList}
                                                    onPreview={this.handlePreview}
                                                    onChange={this.handleChange}
                                                    className="picture-card"
                                                    disabled={true}
                                                >
                                                </Upload>
                                                <Modal visible={this.state.previewVisible} footer={null} onCancel={() => this.setState({ previewVisible: false })}>
                                                    <img alt="example" style={{ width: '100%' }} src={this.state.previewImage} />
                                                </Modal>
                                            </Panel>
                                        )
                                    }
                                    {
                                        dataJobType.length > 0 && (
                                            <Panel
                                                header={<IntlMessages id="Header" />}
                                                key="1"
                                                showArrow={false}
                                                style={{ ...customPanelStyle, marginTop: 24, marginBottom: 10 }}
                                                // extra={<a href="javascript:;" onClick={() => this.showdetail(this.state.dataObservation)}>View Observation</a>}
                                                extra={<Link
                                                    onClick={(e) => { e.stopPropagation(); window.localStorage.setItem('Observ_Hold', JSON.stringify({ Obtran: this.state.dataObservation, mode: 'view' })) }}
                                                    to={{ pathname: '/observation/request/' + this.state.ObtranID + '/view' }}
                                                    target="_blank"
                                                >
                                                    <IntlMessages id="Capa.ViewObservation" />
                                                </Link>}
                                            >
                                                <strong><IntlMessages id='CreatedBy' /></strong>
                                                <p>{this.state.dataObservation.CreateByName}</p>
                                                <strong><IntlMessages id='Summary.job_type' /></strong>
                                                <ul>
                                                    {
                                                        dataJobType.map((l, i) => {
                                                            return (
                                                                <li key={l.JobType1}><p>{this.state.isEng ? l.JobType_EN : l.JobType1}</p></li>
                                                            )
                                                        })
                                                    }
                                                </ul>
                                                <strong><IntlMessages id='Summary.unsafe_detail' /></strong>
                                                <Table columns={columns_unsafe_detail_category} dataSource={data_category_unsafe} size="small" style={{ padding: "0" }} pagination={false} />
                                                <strong><IntlMessages id='Summary.root_cause' /></strong>
                                                <Table columns={columns_rootcause} dataSource={data_rootcause} size="small" style={{ padding: "0" }} pagination={false} />
                                            </Panel>
                                        )
                                    }
                                    <Panel header={<IntlMessages id='Details' />} key="4" showArrow={false} style={{ ...customPanelStyle, marginTop: 24, marginBottom: 10 }}>
                                        <>
                                            {/* <strong>Immediate corrective action</strong>
                                            <TextArea value={Unsafe_detail_corrective_action} autosize readOnly /> */}
                                            <strong><IntlMessages id='Action.next_action' /></strong>
                                            {/* <TextArea value={Unsafe_detail_next_action} autosize readOnly /> */}
                                            <p>{Unsafe_detail_next_action}</p>
                                            <strong><IntlMessages id='Action.observation_type' /></strong>
                                            {/* <TextArea value={action_type} autosize readOnly /> */}
                                            <p> {this.state.isChangeAssignee ? <IntlMessages id='forward' /> : <IntlMessages id={this.state.dataObservation.ActionType + ''} />}</p>
                                        </>
                                    </Panel>
                                    {
                                        this.state.PageMode === mode.Assignee ? (
                                            <Panel header={<IntlMessages id="ResponsiblePerson" />} key="8" extra={genSwitchCangeAssignee()} showArrow={false} style={{ ...customPanelStyle, marginTop: 24, marginBottom: 10 }}>
                                                {this.state.isChangeAssignee ? (
                                                    <Search
                                                        width="100%"
                                                        placeholder="Select responsible"
                                                        onSearch={this.handleShowSearch}
                                                        value={this.state.selectedUser.fullNameTH}
                                                        readOnly={true}
                                                        enterButton
                                                    />
                                                ) : (
                                                        <p>
                                                            {this.state.dataObservation.ResponsibleName}
                                                        </p>
                                                    )
                                                }
                                            </Panel>
                                        ) : (
                                                <Panel header={<IntlMessages id="ResponsiblePerson" />} key="8" showArrow={false} style={{ ...customPanelStyle, marginTop: 24, marginBottom: 10 }}>

                                                    <p>
                                                        {this.state.dataObservation.ResponsibleName}
                                                    </p>

                                                </Panel>
                                            )
                                    }
                                    {
                                        !this.state.isFirst ? (
                                            <Panel header={<IntlMessages id='DueDate' />} key="9" showArrow={false} style={{ ...customPanelStyle, marginTop: 24, marginBottom: 10 }}>
                                                {
                                                    this.state.dataObservation.CurrentStatus === 7 ? (
                                                        <DatePicker
                                                            format='DD/MM/YYYY'
                                                            style={{ width: '100%' }}
                                                            defaultValue={moment(this.state.dataObservation.DueDate, 'YYYY-MM-DD')}
                                                            onChange={(value) => {
                                                                let due_date = value
                                                                due_date.toJSON = function () { return moment(this).format(); }
                                                                let dueDateStr = JSON.stringify(due_date)
                                                                let observation_due_date = dueDateStr.slice(1, 11)
                                                                this.setState({
                                                                    dataObservation: {
                                                                        ...this.state.dataObservation,
                                                                        DueDate: observation_due_date
                                                                    }
                                                                })
                                                            }} />
                                                    ) : (
                                                            <p>
                                                                {this.state.dataObservation.DueDate ? moment(this.state.dataObservation.DueDate, 'YYYY-MM-DD').format('DD/MM/YYYY') : ''}
                                                            </p>
                                                        )
                                                }

                                            </Panel>
                                        ) : null
                                    }


                                    {
                                        this.state.isFirst && !this.state.isChangeAssignee ? (
                                            <Panel header={<IntlMessages id='DueDate' />} key="10" showArrow={false} style={{ ...customPanelStyle, marginTop: 24, marginBottom: 10 }}>
                                                <DatePicker
                                                    format='DD/MM/YYYY'
                                                    style={{ width: '100%' }}
                                                    // defaultValue={moment(new Date(), 'YYYY-MM-DD')}
                                                    onChange={(value) => {
                                                        if (value === null) {
                                                            this.setState({
                                                                dataObservation: {
                                                                    ...this.state.dataObservation,
                                                                    DueDate: null
                                                                }
                                                            })
                                                        } else {
                                                            let due_date = value
                                                            due_date.toJSON = function () { return moment(this).format(); }
                                                            let dueDateStr = JSON.stringify(due_date)
                                                            let observation_due_date = dueDateStr.slice(1, 11)
                                                            this.setState({
                                                                dataObservation: {
                                                                    ...this.state.dataObservation,
                                                                    DueDate: observation_due_date
                                                                }
                                                            })
                                                        }

                                                    }} />
                                            </Panel>
                                        ) : null
                                    }
                                    {
                                        !this.state.isFirst && (((!this.state.isChangeAssignee && this.state.PageMode === mode.Assignee) || this.state.PageMode === mode.Manager) && this.state.PageMode !== mode.readOnly && this.state.dataObservation.CurrentStatus !== 7) ? (
                                            <Panel header={<IntlMessages id='Action' />} key="11" showArrow={false} style={{ ...customPanelStyle, marginTop: 24, marginBottom: 10 }}>
                                                <>
                                                    {
                                                        this.state.PageMode === mode.Assignee ? (
                                                            <>
                                                                <strong>Select Action</strong>
                                                                <Select
                                                                    style={{ width: '100%' }}
                                                                    placeholder="Select ation"
                                                                    onChange={this.handleChangeAction}
                                                                >
                                                                    <Option value="completed">Update CA/PA Completed</Option>
                                                                    <Option value="revised">Revised due date</Option>
                                                                    <Option value="cancelled">Cancel</Option>
                                                                </Select>
                                                            </>
                                                        ) : null
                                                    }

                                                    <strong><IntlMessages id='Remarks' /></strong>
                                                    <TextArea autosize={{ minRows: 2 }} onChange={this.handleChangeRemark} />
                                                    {
                                                        this.state.capaAction == 'completed' && (
                                                            <>
                                                                <strong>CA/PA Complete Date</strong>
                                                                <DatePicker format='DD/MM/YYYY' style={{ width: '100%' }} onChange={(value) => {
                                                                    let complete_date = value
                                                                    complete_date.toJSON = function () { return moment(this).format(); }
                                                                    let completeDateStr = JSON.stringify(complete_date)
                                                                    let observation_complete_date = completeDateStr.slice(1, 11)
                                                                    this.setState({
                                                                        completeDate: observation_complete_date
                                                                    })
                                                                }} />
                                                            </>
                                                        )
                                                    }

                                                </>
                                            </Panel>
                                        ) : null
                                    }

                                    <Panel header={<IntlMessages id='Capa.WorkflowHistory' />} key="12" showArrow={false} style={{ ...customPanelStyle, marginTop: 24, marginBottom: 10 }}>
                                        <Table
                                            dataSource={this.state.dataWorkflow}
                                            size="small"
                                            style={{ padding: "0" }}
                                            pagination={false}>
                                            <Column
                                                key={1}
                                                title={<IntlMessages id='Name' />}
                                                dataIndex={this.state.isEng ? 'ActionByName_EN' : 'ActionByName'}
                                            />
                                            <Column
                                                key={2}
                                                title={<IntlMessages id='DateTime' />}
                                                dataIndex='ActionDate'
                                                render={datetime => {
                                                    let date = datetime ? moment(datetime, 'YYYY-MM-DD HH:mm').format('DD/MM/YYYY HH:mm') : ''
                                                    return (
                                                        <>
                                                            {date}
                                                        </>
                                                    )

                                                }}
                                            />
                                            <Column
                                                key={3}
                                                title={<IntlMessages id='Action' />}
                                                dataIndex='Action'
                                                render={status => {
                                                    let state_text = this.state.status.length > 0 ? this.state.status.find(x => x.StatusId === status).StatusName : '';
                                                    return (
                                                        <span>
                                                            {
                                                                <Tag color='red' key={status}>
                                                                    {state_text}
                                                                </Tag>
                                                            }
                                                        </span>
                                                    )
                                                }}
                                            />
                                            <Column
                                                key={4}
                                                title={<IntlMessages id='Status' />}
                                                dataIndex='CurrentStatus'
                                                render={status => {
                                                    let state_text = this.state.status.length > 0 ? this.state.status.find(x => x.StatusId === status).StatusName : '';
                                                    return (
                                                        <span>
                                                            {
                                                                <Tag color='red' key={status}>
                                                                    {state_text}
                                                                </Tag>
                                                            }
                                                        </span>
                                                    )
                                                }}
                                            />
                                            <Column
                                                key={5}
                                                title={<IntlMessages id='Remarks' />}
                                                dataIndex='Remark'
                                            />
                                        </Table>
                                    </Panel>
                                </Collapse>
                            </div>
                        </div>

                        <Modal
                            title="เลือกผู้รับผิดชอบ"
                            visible={this.state.visible}
                            onOk={this.handleUserOk}
                            onCancel={this.handleUserCalcel}
                            width={'95%'}
                        >
                            <Search placeholder="Search user" enterButton onSearch={value => this.handleSearch(value)} />
                            <Table
                                rowSelection={rowSelection}
                                dataSource={this.state.user}
                                loading={this.state.onloadUser}
                            >
                                <Column
                                    title='Fullname (TH)'
                                    dataIndex='fullNameTH'
                                />
                                <Column
                                    title='Fullname (EN)'
                                    dataIndex='fullNameEN'
                                />
                                <Column
                                    title='Company'
                                    dataIndex='company'
                                />
                                <Column
                                    title='Division'
                                    dataIndex='division'
                                />
                                <Column
                                    title='Department'
                                    dataIndex='department'
                                />
                                <Column
                                    title='Email'
                                    dataIndex='email'
                                />
                            </Table>
                        </Modal>
                    </MenuSider>
                </Spin>
                {
                    this.state.PageMode === mode.Assignee && this.state.dataObservation.CurrentStatus !== 2 && this.state.dataObservation.CurrentStatus !== 6 ? (
                        <div style={{ width: "100%", textAlign: "center", position: "relative", bottom: "0", height: "48px" }} >
                            <Button
                                disabled={this.state.clicked}
                                htmlType="button"
                                style={{ width: "100%", height: "100%", fontSize: "18px", display: "inline-block", border: "1px solid rgb(1 135 124)", padding: "3px", color: "white", backgroundColor: "rgb(0,152,139)", borderRadius: "0" }}
                                onClick={() => this.handleSubmit()}
                            >
                                <IntlMessages id='Submit' />
                            </Button>
                        </div>
                    ) : null
                }
                {
                    this.state.PageMode === mode.Manager && this.state.dataObservation.CurrentStatus === 2 && this.state.dataObservation.CurrentStatus !== 6 ? (
                        <div style={{ width: "100%", textAlign: "center", position: "relative", bottom: "0", height: "48px" }} >
                            <Button
                                disabled={this.state.clicked}
                                htmlType="button"
                                style={{ width: "50%", height: "100%", fontSize: "18px", display: "inline-block", border: "1px solid rgb(1 135 124)", padding: "3px", color: "white", backgroundColor: "rgb(0,152,139)", borderRadius: "0" }}
                                onClick={() => this.handleApprove('reject')}
                            >
                                <IntlMessages id='Reject' />
                            </Button>
                            <Button
                                disabled={this.state.clicked}
                                htmlType="button"
                                style={{ width: "50%", height: "100%", fontSize: "18px", float: "right", display: "inline-block", border: "1px solid #0dba07", padding: "3px", color: "white", backgroundColor: "#0dba07", borderRadius: "0" }}
                                onClick={() => this.handleApprove('approve')}
                            >
                                <IntlMessages id='Approve' />
                            </Button>
                        </div>
                    ) : null
                }
            </div >
        )
    }
}